import React from "react";
import { useMutation } from "@apollo/client";
import { FormattedMessage } from "react-intl";
import { useModalConfirmation, useToast } from "hooks";
import { APPROVE_MISSION_ROLE } from "graphql/mutations";
import { GET_MISSION_ROLES } from "graphql/queries";

/**
 * useRoleBuilderSubmit
 *
 * Submits the finished draft to Open Roles, unpublished, once the customer confirms.
 *
 * @param {Object}    draftRole  The draft being built
 * @param {Function}  onClose    Called once the role is submitted
 */
export default function useRoleBuilderSubmit({ draftRole, onClose } = {}) {
  const { show: confirm } = useModalConfirmation();
  const { toast } = useToast();
  const [approveRole, { loading }] = useMutation(APPROVE_MISSION_ROLE);

  const submitRole = async (role = draftRole) => {
    const confirmed = await confirm(
      <FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Submit.Confirm.Title" />,
      <FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Submit.Confirm.Description" />,
      { primaryButtonMessageId: "Global.Confirm" }
    );

    if (!confirmed) return;

    approveRole({
      variables: { input: { id: role.id } },
      refetchQueries: [GET_MISSION_ROLES],
      onCompleted: () => {
        toast.success(<FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Submit.Success" />);
        onClose?.();
      },
      onError: (error) => toast.error(error?.message),
    });
  };

  return { submitRole, submitting: loading };
}
